import moment from 'moment';

class MarkProcessedModalController {
  constructor($uibModalInstance, modalContext) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.modalContext = modalContext || {};
    this.reportName = this.modalContext.reportName || 'this expense report';
    this.reimbursementAmount = this.modalContext.reimbursementAmount || '$0.00';
    this.totalCost = this.modalContext.totalCost || null;

    this.maxProcessedDate = moment().format('YYYY-MM-DD');
    this.processedDate = moment().format('YYYY-MM-DD');
    this.processedDateText = moment().format('MMM DD, YYYY');
    this.notifyEmployee = false;
    this.errorMessage = '';
  }

  onProcessedDateSelected(selectedDate) {
    if (!selectedDate) {
      return;
    }
    this.processedDate = moment(selectedDate).format('YYYY-MM-DD');
    this.processedDateText = moment(selectedDate).format('MMM DD, YYYY');
    this.errorMessage = '';
  }

  onProcessedDateTextChange() {
    const parsed = moment(this.processedDateText, ['MMM DD, YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'], true);
    if (parsed.isValid()) {
      this.processedDate = parsed.format('YYYY-MM-DD');
      this.processedDateText = parsed.format('MMM DD, YYYY');
      this.errorMessage = '';
    } else {
      this.processedDate = null;
    }
  }

  confirm() {
    if (!this.processedDate) {
      this.errorMessage = 'Select the date this reimbursement was processed.';
      return;
    }

    const selected = moment(this.processedDate).startOf('day');
    if (!selected.isValid()) {
      this.errorMessage = 'Enter a valid processed date.';
      return;
    }

    if (selected.isAfter(moment().startOf('day'))) {
      this.errorMessage = 'Processed date cannot be in the future.';
      return;
    }

    this.$uibModalInstance.close({
      processedDate: selected.format('YYYY-MM-DD'),
      notify: !!this.notifyEmployee
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default MarkProcessedModalController;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-review-details/modals/mark-processed/mark-processed.controller.js